import logo from "@/assets/vairam-logo-l.webp";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 bg-gradient-gold rounded-full flex items-center justify-center p-1 shadow-premium">
          <img
            src={logo}
            alt="Logo"
            className="w-full h-full object-contain rounded-full"
          />
        </div>
        <p className="text-muted-foreground font-medium tracking-wider">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default PageLoader;